import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-draggable-legend',
  templateUrl: './draggable-legend.component.html',
  styleUrls: ['./draggable-legend.component.scss']
})
export class DraggableLegendComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DraggableLegendComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; image }
  ) {}

  ngOnInit(): void {}
}
